import { Content } from './types'

const glossary: Content = {
    type: 'glossary',
    name: 'Begrippenlijst',
}

export default glossary
